import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import relativeRiskDetails from '../relativeRiskDetails';
import impactAnalysisGraph from '../impactAnalysisGraph';
import recoveryPointObjectives from '../recoveryPointObjectives';
import controller from './approve-impact-analysis-dialog.controller';
import template from './approve-impact-analysis-dialog.html';


class dialogService {
  getOptions($event, { processes }) {
    return {
      controller,
      controllerAs: 'approveImpactAnalysisDialogVM',
      locals: {
        processes
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.approveImpactAnalysisDialog', [
  alerts,
  bcpDataService,
  constants,
  impactAnalysisGraph,
  recoveryPointObjectives,
  loaderService,
  relativeRiskDetails,
  ssDialogService,
])
  .service('approveImpactAnalysisDialog', dialogService)
  .name;
